import React, { FC } from 'react';

interface RichTextProps {
  html: string | null | undefined;
  component?: 'span' | 'div';
  className?: string;
}

// The HTML this component renders has already been sanitized server-side at write time (see
// RichTextSanitizer in longhouse.api Mutation.cs). The Tiptap editor and the server allowlist
// agree on the same set of inline marks, so what gets stored is always safe to render.
export const RichText: FC<RichTextProps> = ({ html, component: Tag = 'span', className }) => {
  if (!html) return null;
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};
